// Highcharts' exporting context menu ("Print chart", "Download PNG image", ...) has its own
// `lang` strings, separate from vue-i18n — Highcharts.setOptions() is the only way to localize
// them. Language changes reload the app (LanguageModal.vue), so setting this once at boot from
// the active locale is enough.

export const HIGHCHARTS_LANG = {
  de: {
    contextButtonTitle: 'Diagramm-Kontextmenü',
    viewFullscreen: 'Vollbildansicht',
    exitFullscreen: 'Vollbildmodus verlassen',
    printChart: 'Diagramm drucken',
    downloadPNG: 'PNG-Bild herunterladen',
    downloadJPEG: 'JPEG-Bild herunterladen',
    downloadPDF: 'PDF-Dokument herunterladen',
    downloadSVG: 'SVG-Vektorbild herunterladen'
  },
  it: {
    contextButtonTitle: 'Menu contestuale del grafico',
    viewFullscreen: 'Visualizza a schermo intero',
    exitFullscreen: 'Esci dallo schermo intero',
    printChart: 'Stampa grafico',
    downloadPNG: 'Scarica immagine PNG',
    downloadJPEG: 'Scarica immagine JPEG',
    downloadPDF: 'Scarica documento PDF',
    downloadSVG: 'Scarica immagine vettoriale SVG'
  }
}
